module.exports = __webpack_public_path__ + "static/img/13tekst.faf210c7.png";